import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a4cc44e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-primary-dark text-center my-6 font-bold font-sarabun text-32px lg-text-56px leading-10" }, " 10 Years Goals ", -1))
const _hoisted_3 = { class: "w-1/6 lg:w-1/4 -mx-4 lg:ml-48" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "v-stepper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle w-7 h-7" }),
  /*#__PURE__*/_createElementVNode("div", { class: "line" })
], -1))
const _hoisted_5 = { class: "max-w-xs pr-2" }
const _hoisted_6 = { class: "content pl-2 lg:pl-12 flex" }
const _hoisted_7 = { class: "list flex-wrap" }
const _hoisted_8 = {
  key: 1,
  style: {"background":"#dfe1e6"},
  class: "w-5 h-5 rounded-full"
}
const _hoisted_9 = { class: "text-primary-dark text-20px lg:text-28" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full lg:w-auto" }, null, -1))
const _hoisted_11 = { class: "w-full lg:w-96 max-w-xs lg:max-w-md relative" }
const _hoisted_12 = { class: "progress mt-6 mb-2 md:my-2" }
const _hoisted_13 = { class: "text-sm font-light text-gray-description absolute right-0" }

import IconCorrect from '@/components/Icons/IconCorrect.vue';
import Moralis from 'moralis';
import { MoralisKey } from '@/symbols/moralis';
import { inject } from 'vue';
import { onMounted, ref } from 'vue';
import { Goals } from '@/types/MoralisCloud';
import { currencyNumber } from '@/utils/numbers';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const moralis = inject(MoralisKey, Moralis);
const goals = ref<Goals[]>();

onMounted(async () => {
  goals.value = await moralis.Cloud.run('getGoals');
});

const getGoalProgress = (progress: number) => progress.toFixed(2);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goals.value, (g, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["step pt-8 mb-10 lg:mb-20", { completed: g.progress != 0 }]),
          key: i
        }, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "header pl-2 lg:pl-12",
              style: _normalizeStyle({ width: `${g.progress != 0 ? 'calc(100%-60px)' : ''}` })
            }, _toDisplayString(g.year), 5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (g.progress != 0)
                  ? (_openBlock(), _createBlock(IconCorrect, { key: 0 }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(currencyNumber)(g.goal)) + " m2 Forest Area Planted ", 1),
                _hoisted_10,
                _withDirectives(_createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", {
                      class: "bg-primary h-full",
                      style: _normalizeStyle([{"border-radius":"6px"}, `width: ${g.percentage}%;`])
                    }, null, 4)
                  ]),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(currencyNumber)(getGoalProgress(g.progress))) + "/" + _toDisplayString(_unref(currencyNumber)(g.goal)), 1)
                ], 512), [
                  [_vShow, g.progress != 0]
                ])
              ])
            ])
          ])
        ], 2))
      }), 128))
    ])
  ]))
}
}

})